import { render, staticRenderFns } from "./downYieldXin.vue?vue&type=template&id=0410f49a&scoped=true&"
import script from "./downYieldXin.vue?vue&type=script&lang=js&"
export * from "./downYieldXin.vue?vue&type=script&lang=js&"
import style0 from "./downYieldXin.vue?vue&type=style&index=0&id=0410f49a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0410f49a",
  null
  
)

export default component.exports